import axios, { AxiosResponse } from "axios";
import { ApiResult, AxiosErr } from "../Contracts/IMdels";
import { BaseModel } from "./BaseModel";

export class SubscriberModel extends BaseModel {
  RouteName = "Subscribe";
  protected AuthState: boolean = true;
  public async get(id: number): Promise<AxiosResponse<ApiResult>> {
    try {
      return await this.baseApi
        .axiosInstance(this.AuthState)
        .get(`${this.RouteName}/custom?id=${id}`);
    } catch (e) {
      const error = e as AxiosErr;
      throw error.response?.data.message;
    }
  }

  public async getAllWithPaginate(pageNumber: number, pageSize = 10) {
    try {
      return await this.baseApi
        .axiosInstance(this.AuthState)
        .get(`${this.RouteName}/page?pageNumber=${pageNumber}&pageSize=${pageSize}`);
    } catch (e: any) {
      const error = e as AxiosErr;
      if (axios.isCancel(error)) {
        throw error.message;
      }

      throw error.response?.data.message;
    }
  }
  public async getDetail(id: number): Promise<AxiosResponse<ApiResult>> {
    try {
      return await this.baseApi
        .axiosInstance(this.AuthState)
        .get(`${this.RouteName}/detail?id=${id}`);
    } catch (e) {
      const error = e as AxiosErr;
      throw error.response?.data.message;
    }
  }
}
